import React from "react";
import DashboardKpiStatus from "components/DashboardKpiStatus";
import { useState } from "react";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { Card, CardContent, Grid, Typography, Avatar, Box } from "@mui/material";
// import { mapScheduleKpis } from "view/dashboard/schedule/scheduleKpiMapper"
import { useLazyGetAllProjectRiskQuery, } from "store/slices/apis/projectRiskSlice";
import RiskPopUp from "./kpiListPopup";
import { useParams } from "react-router-dom";
import moment from "moment";
import StatusBadge from "components/badge/StatusBadge";
import RiskSeverityBadge from "components/badge/RiskSeverityBadge";




// const kpis = [
//     { type: "days", label: "Total Risk", value: "18", bg: "#FFE2E5", iconBg: "#FA5A7D" },
//     { type: "days", label: "Active Risk", value: "18", bg: "#FFF4DE", iconBg: "#FE970A" },
//     { type: "days", label: "Overdue Risk", value: "1", bg: "#FFE2E5", iconBg: "#FA5A7D" },
//     { type: "days", label: "Completed Risk", value: "0", bg: "#DCFCE7", iconBg: "#68C485" },
//     { type: "days", label: "Average Closure Duration", value: "NA", bg: "#FFF4DE", iconBg: "#FE970A" },
//     { type: "days", label: "Risk with Scheduled Impact", value: "22%", bg: "#F3E8FF", iconBg: "#6200EE" },
//     { type: "days", label: "Risk with Cost Impact", value: "28%", bg: "#FFE2E5", iconBg: "#FA5A7D" },
// ];

const RiskKpi = ({ kpiData }) => {


    const [selectedCategory, setSelectedCategory] = useState(null);
    const [isViewTracker, setIsViewTracker] = useState(false);

    const handleClose = () => setIsViewTracker(false);


    const handleClick = (key) => {
        setSelectedCategory(key.label)
        setIsViewTracker(true);
    }


    const kpis = [
        { type: "days", label: "Total Risk", value: kpiData?.data?.totalRisk ?? 0, bg: "#FFE2E5", iconBg: "#FA5A7D" },
        { type: "days", label: "Active Risk", value: kpiData?.data?.activeRisk ?? 0, bg: "#FFF4DE", iconBg: "#FE970A" },
        { type: "days", label: "Overdue Risk", value: kpiData?.data?.overdueRisk ?? 0, bg: "#FFE2E5", iconBg: "#FA5A7D" },
        { type: "days", label: "Closed Risk", value: kpiData?.data?.completedRisk ?? 0, bg: "#DCFCE7", iconBg: "#68C485" },
        { type: "days", label: "Mitigation List", value: 'Mitigation', bg: "#FFF4DE", iconBg: "#FE970A" },
        { type: "days", label: "Risk with Scheduled Impact", value: `${kpiData?.data?.riskWithScheduleImpactPercent}%` ?? '0%', bg: "#F3E8FF", iconBg: "#6200EE" },
        { type: "days", label: "Risk with Cost Impact", value: `${kpiData?.data?.riskWithCostImpactPercent}%` ?? '0%', bg: "#FFE2E5", iconBg: "#FA5A7D" },
    ];

    const columns = [
        // {
        //     name: "",
        //     field: "actions",
        //     width: "10px",
        //     sticky: true,
        //     renderer: (row) => (
        //         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        //             <IconButton
        //                 size="small"
        //                 onClick={(e) => handleMenuOpen(e, row)}
        //             >
        //                 <MoreVertIcon fontSize="small" />
        //             </IconButton>
        //         </Box>
        //     ),
        // },
        {
            name: "ID",
            field: "customId",
            width: "130px",
            sticky: true,
        },
        {
            name: "Title",
            field: "title",
            width: "360px",
            sticky: true,

        },
        {
            name: "Category",
            field: "category",
            sticky: true,

        },
        {
            name: 'Status',
            field: 'riskStatus',
            renderer: (row) => (
                <StatusBadge status={row?.riskStatus} />
            )
        },
        {
            name: "Likelihood",
            field: "likelihood",
        },
        {
            name: "Impact",
            field: "impact",
        },
        {
            name: "Risk Rating",
            field: "riskRating",
        },
        {
            name: "Severity",
            field: "severity",
            renderer: (row) => (
                <RiskSeverityBadge status={row?.severity} />
            )
        },
        {
            name: "Mitigation Action Status",
            field: "mitigationActionStatus",

        },
        {
            name: "Target Closure Date",
            field: "targetClosureDate",
            renderer: (row) => (
                row?.targetClosureDate ? moment.utc(row.targetClosureDate).format("DD MMM YYYY") : "N/A"
            ),
        },
        {
            name: "Entity/Person Responsible",
            field: "entityPersonResponsible",
        },
    ];


    return (
        <>
            <Card
                elevation={0}
                sx={{
                    borderRadius: "3px",
                    border: "1px solid #eef0f4",
                    p: 1.5,
                    width: "100%",
                    boxSizing: "border-box",
                    maxHeight: { md: "330px", xs: "auto" },
                }}
            >
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 600,
                        fontSize: "15px",
                        lineHeight: "21px",
                        letterSpacing: "0px",
                        mb: "4px",
                    }}
                >
                    Risk Intelligence
                </Typography>
                <Typography
                    sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 300,
                        fontSize: "12px",
                        lineHeight: "21px",
                        letterSpacing: "0px",
                        mb: "20px",
                    }}
                >
                    Active exposure, mitigation progress, and delivery impact in one view.
                </Typography>

                <Grid container sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
                    gap: 1.25,
                    width: "100%",
                    "& > .MuiGrid-root": { minWidth: 0, width: "auto", maxWidth: "none" },
                    "& .MuiCard-root": { transition: "border-color 140ms ease, box-shadow 140ms ease, transform 140ms ease" },
                    "& .MuiCard-root:hover": { borderColor: "#CBD5E1", boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)", transform: "translateY(-1px)" },
                }}>
                    {kpis?.map((item) => (
                        <Grid xs={12} sm={6} md={12 / 7} key={item.label} sx={{ minWidth: 0 }}>
                            <Card
                                elevation={0}
                                onClick={() => handleClick(item)}
                                sx={{
                                    height: "128px",
                  position: "relative",
                                    // width: { xs: "200px", md: "auto" },
                                    borderRadius: "3px",
                                    backgroundColor: "#FFFFFF",
                  border: "1px solid #E2E8F0",
                  borderBottom: `3px solid ${item.iconBg}`,
                                    cursor: "pointer"
                                }}
                            >
                                <CardContent sx={{ gap: 1, p: 1.25, pt: 1.25 }}>
                                    <Avatar
                                        sx={{
                                            width: 30,
                                            height: 30,
                                            backgroundColor: item.iconBg,
                                            fontSize: 18,
                                            fontWeight: 700,
                                        }}
                                    >
                                        <MdOutlineCalendarMonth />
                                    </Avatar>
                  <DashboardKpiStatus color={item.iconBg} />
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            gap: "13px",
                                            mt: "4px",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontFamily: "Outfit, sans-serif",
                                                fontWeight: 700,       // highlight the value
                                                fontSize: "16px",
                                                lineHeight: "21px",
                                                color: "#151D48",
                                                // mt: "12px",            // more breathing room
                                                mb: "4px",
                                            }}
                                        >
                                            {item.value}
                                        </Typography>
                                    </Box>

                                    <Typography
                                        sx={{
                                            fontFamily: "Outfit, sans-serif",
                                            fontWeight: 500,
                                            lineHeight: "16px",
                                            fontSize: "12px",
                                            letterSpacing: "0px",
                                            color: "#425166",
                                            mt: "5px",
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                    {item.value == "Mitigation" &&
                                        <>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                    color: "#4B5563",
                                                }}
                                            >
                                                Mitigated :{" "}
                                                <strong>{kpiData?.data?.mitigatedRisk ?? 0}</strong>
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 400,
                                                    fontSize: "12px",
                                                    color: "#4B5563",
                                                }}
                                            >
                                                Not Mitigated:{" "}
                                                <strong>{kpiData?.data?.nonMitigatedRisk ?? 0}</strong>
                                            </Typography>
                                        </>
                                    }

                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Card>
            {isViewTracker && (
                <RiskPopUp
                    header={selectedCategory}
                    open={isViewTracker}
                    handleClose={handleClose}
                    label={selectedCategory}
                    columns={columns}
                />
            )}
        </>
    );
};

export default RiskKpi;
